import { addDoc, onSnapshot } from 'firebase/firestore';
import { studentSubCol } from '../firebase/config';
import { formatDateTR } from '../utils/dateUtils';
import { generateId } from '../utils/stringUtils';

export async function addSwimmingRecord(studentId, { style, time, dateISO }) {
  const formattedDate = formatDateTR(dateISO);
  await addDoc(studentSubCol(studentId, 'swimmingRecords'), {
    id: generateId(),
    style,
    time,
    date: formattedDate,
    timestamp: Date.now(),
  });
}

/** Tek öğrencinin dereceleri (canlı); timestamp alanı olmayan eski kayıtlar da gelsin diye sunucuda sıralanmaz */
export function subscribeSwimmingRecords(studentId, onData, onError) {
  return onSnapshot(
    studentSubCol(studentId, 'swimmingRecords'),
    (snap) => onData(snap.docs.map((d) => ({ ...d.data(), id: d.id }))),
    onError
  );
}
